import awards1_2023 from '@/public/awards/2023/2023_1.webp';
import awards2_2023 from '@/public/awards/2023/2023-2.webp';
import awards3_2023 from '@/public/awards/2023/2023-3.webp';
import awards4_2023 from '@/public/awards/2023/2023-4.webp';
import awards5_2023 from '@/public/awards/2023/2023-5.webp';
import awards6_2023 from '@/public/awards/2023/2023-6.webp';
import awards1_2024 from '@/public/awards/2024/2024_1.webp';
import awards2_2024 from '@/public/awards/2024/2024_2.webp';
import awards3_2024 from '@/public/awards/2024/2024_3.webp';
import awards4_2024 from '@/public/awards/2024/2024_4.webp';
import awards5_2024 from '@/public/awards/2024/2024_5.webp';
import awards6_2024 from '@/public/awards/2024/2024_6.webp';
import awards1 from '@/public/awards/top-performer-winter-white-_1_-_1__1.webp';
import explore_image from '@/public/features/explore.webp';
import app_1 from '@/public/features/scheduling/App_1.webp';
import app_2 from '@/public/features/scheduling/App_2.webp';
import schedule_1 from '@/public/features/scheduling/Schedule_1.webp';
import schedule_2 from '@/public/features/scheduling/Schedule_2.webp';
import schedule_3 from '@/public/features/scheduling/Schedule_3.webp';
import bg from '@/public/features/scheduling/scheduling.webp';
import {
  CalculatorIcon,
  CalendarIcon,
  CardIcon,
  ClockTimeIcon,
  DocumentIcon,
  EmailIcon,
  GroupIcon,
  LaptopIcon,
  ScheduleIcon,
  StarsBlueIcon,
  ToolsIcon,
  WalletIcon,
} from '@/public/icons';
import AirloopImage from '@/public/partners/Airloop_heating_air.webp';
import GarantImage from '@/public/partners/Appliance_servicenter.webp';
import BuildxImage from '@/public/partners/BuildX.webp';
import RemovalImage from '@/public/partners/RemovalPro.webp';
import review1 from '@/public/reviews/CapterraSvg.svg';
import review2 from '@/public/reviews/GetAppSvg.svg';
import review3 from '@/public/reviews/SoftwareAdvice.svg';
import applianceImage from '@/public/services/appliance_service.webp';
import cleaningImage from '@/public/services/cleaning_service.webp';
import electricalImage from '@/public/services/electrical_service.webp';
import garageImage from '@/public/services/garage_doors_service.webp';
import hvacImage from '@/public/services/hvac_service.webp';
import junkImage from '@/public/services/junk_remoal_service.webp';
import locksmithImage from '@/public/services/locksmith_service.webp';
import otherImage from '@/public/services/other_service.webp';
import plumbingImage from '@/public/services/plumbing_service.webp';
import propertyImage from '@/public/services/property_maintenance_service.webp';
import whatIsDeskImage from '@/public/what_is_desk.webp';
import whatIsMobImage from '@/public/what_is_mob.webp';
import { ArticleType } from '@/types/articles';
import { IRoutePath } from '@/types/router';

const intro = {
  tag: 'Job Scheduling Software',
  description: `Unlock the potential of your business with our free job schedule software. Our platform is designed to simplify your day-to-day operations, providing an intuitive scheduling system that supports your growth without any financial commitment. Experience the ease of organizing jobs, managing team assignments, and enhancing customer satisfaction, all with software that's free forever.`,
  imageSrc: bg.src,
  image: bg,
  first_title: 'Streamline Your Workflow with Free',
  second_title: 'Job Scheduling Software',
};

const faq = {
  title: 'FAQ',
  items: [
    {
      title: 'Can I use automation to schedule recurring jobs with Orcatec?',
      text: `Orcatec's real-time scheduling software allows you to set up automated recurring job schedules, ensuring consistent service delivery without the manual hassle.`,
    },
    {
      title: `Can my staff control their timesheets on the mobile app?`,
      text: `Orcatec's mobile app empowers your team to manage their timesheets directly, providing real-time updates and seamless integration.`,
    },
    {
      title: `Can I see how long my staff is spending on a task to help with job planning?`,
      text: `Our field service job scheduling software offers detailed task tracking to monitor staff's time on each task, aiding efficient job planning software.`,
    },
    {
      title: `Why would I need field service scheduling software for my small business?`,
      text: `Field service job scheduling software like Orcatec streamlines your operations, providing real-time scheduling. Small businesses benefit from enhanced productivity and customer satisfaction.`,
    },

    {
      title: `Does Orcatec offer free job scheduling software for beginners?`,
      text: `Orcatec offers a real time scheduling software package for free that is perfect for those just starting. Upgrade your scheduling with ease and zero cost.`,
    },
  ],
};

const testimonals = {
  title: 'Client’s Testimonials',
  description: '',
  items: [
    {
      text: `Orcatec's service scheduling program has revolutionized the way we handle our service appointments. It's incredibly intuitive, and everything is just a click away. Our efficiency has skyrocketed!`,
      name: 'Jenna W.',
      position: 'Peak Electric',
      //image: avatar_1,
    },
    {
      text: `I was amazed at how Orcatec's scheduling program managed to simplify our most complicated booking processes. The interface is user-friendly, and the support team is always ready to help.`,
      name: 'Sarah K.',
      position: 'Pure Plumbing Solutions',
      //image: avatar_2,
    },
    {
      text: `Orcatec didn't just provide a scheduling tool; they delivered a comprehensive system that supports all our operational needs. It's been a game-changer for our workflow and customer satisfaction.`,
      name: 'Elizabeth G.',
      position: 'New Age Electrical',
      //image: avatar_3,
    },

    {
      text: `Orcatec's service scheduling program has revolutionized the way we handle our service appointments. It's incredibly intuitive, and everything is just a click away. Our efficiency has skyrocketed!`,
      name: 'Jenna W.',
      position: 'Peak Electric',
      //image: avatar_1,
    },
    {
      text: `I was amazed at how Orcatec's scheduling program managed to simplify our most complicated booking processes. The interface is user-friendly, and the support team is always ready to help.`,
      name: 'Sarah K.',
      position: 'Pure Plumbing Solutions',
      //image: avatar_2,
    },
    {
      text: `Orcatec didn't just provide a scheduling tool; they delivered a comprehensive system that supports all our operational needs. It's been a game-changer for our workflow and customer satisfaction.`,
      name: 'Elizabeth G.',
      position: 'New Age Electrical',
      //image: avatar_3,
    },
  ],
};

const reviews = {
  title: 'Our Reviews',
  items: [
    { path: review1.src, width: review1.width, alt: 'Capterra' },
    { path: review2.src, width: review2.width, alt: 'GetApp' },
    { path: review3.src, width: review3.width, alt: 'Software Advice' },
  ],
};

const services = {
  title: 'Made for Field Service Businesses',
  description:
    'Orcatec is the most suitable solution for field service businesses looking to streamline their operations. Our platform is customized to support a variety of industries, ensuring that whatever your specialty, you have the tools needed to schedule jobs, optimize routes, invoice customers, and get paid – all in one place for your up-to-date home service management system.',
  items: [
    {
      title: 'HVAC',
      path: IRoutePath.INDUSTRIES_HVAC,
      linkTitle: 'Learn More',
      description:
        'Secure more HVAC jobs all year round with service plans, sales proposals, price books, and more',
      image: {
        src: hvacImage.src,
        alt: 'hvac image',
      },
    },
    {
      title: 'Garage Doors',
      path: IRoutePath.INDUSTRIES_GARAGE_DOOR,
      linkTitle: 'Learn More',
      image: {
        src: garageImage.src,
        alt: 'Garage Doors image',
      },
      description:
        'Boost your garage door business by securing more projects and enhancing customer loyalty through service plans, sales proposals, and additional strategies.',
    },
    {
      title: 'Plumbing',
      path: IRoutePath.INDUSTRIES_PLUMBING,
      linkTitle: 'Learn More',
      description:
        'Win more plumbing jobs and close bigger deals with online booking and sales proposals all in one place',
      image: {
        src: plumbingImage.src,
        alt: 'Plumbing image',
      },
    },
    {
      title: 'Property Maintenance',
      path: IRoutePath.INDUSTRIES,
      linkTitle: 'Learn More',
      image: {
        src: propertyImage.src,
        alt: 'Property Maintenance image',
      },
      description:
        'Stay on top of property maintenance tasks effortlessly. Orcatec offers tools for scheduling, invoicing, and customer support.',
    },
    {
      title: 'Electrical',
      path: IRoutePath.INDUSTRIES_ELECTRICIAN,
      linkTitle: 'Learn More',
      image: {
        src: electricalImage.src,
        alt: 'Electrical image',
      },
      description:
        'Organize your electrician business thoroughly, boost efficiency, and improve communication flows',
    },
    {
      title: 'Locksmith',
      path: IRoutePath.INDUSTRIES,
      linkTitle: 'Learn More',
      description:
        'Make your locksmith business more efficient with online booking, quick dispatching, and scheduling',
      image: {
        src: locksmithImage.src,
        alt: 'Locksmith image',
      },
    },
    {
      title: 'Appliance Repair',
      path: IRoutePath.INDUSTRIES_APPLIANCE,
      linkTitle: 'Learn More',
      image: {
        src: applianceImage.src,
        alt: 'Appliance Repair',
      },
      description:
        'Optimize the operation of your appliance repair business through streamlined inventory management and convenient online booking systems',
    },

    {
      title: 'Junk Removal',
      path: IRoutePath.INDUSTRIES,
      linkTitle: 'Learn More',
      image: {
        src: junkImage.src,
        alt: 'Junk Removal image',
      },
      description:
        'Become the leading junk removal company by utilizing a comprehensive suite of tools designed to enhance and expand your business operations',
    },
    {
      title: 'Home Cleaning',
      path: IRoutePath.INDUSTRIES,
      linkTitle: 'Learn More',
      image: {
        src: cleaningImage.src,
        alt: 'Home Cleaning image',
      },
      description: `Elevate your home cleaning services with Orcatec's platform, offering easy appointment scheduling and customer communication.`,
    },

    {
      title: 'Other Industries',
      path: IRoutePath.INDUSTRIES,
      linkTitle: 'More Industries',
      image: {
        src: otherImage.src,
        alt: 'Other Industries image',
      },
      description: `No matter your industry, we have all the tools you need to run your business like a pro.`,
    },
  ],
};

const potential = {
  title: 'Manage Your Business Easily',
  description:
    'Orcatec provides an innovative business management platform that integrates various essential home services software tools to help contractors manage their operations more efficiently and effectively. With its user-friendly interface and a wide array of features, Orcatec ensures that businesses can easily handle their day-to-day tasks, ultimately leading to increased productivity and profitability.',
  items: [
    {
      tag: 'Dispatch',
      title: 'Easily set up appointments with your clients',
      icon: CalendarIcon,
    },
    {
      tag: 'Schedule',
      title: `Efficiently plan your team's tasks and optimize routes using AI`,
      icon: ScheduleIcon,
    },
    {
      tag: 'Accounting',
      title: 'Evaluate your current and future profits ',
      icon: CalculatorIcon,
    },

    {
      tag: 'Email campaign',
      title: 'Boost your sales using effective marketing tools',
      icon: EmailIcon,
    },
    {
      tag: 'Estimates',
      title: 'Generate field proposals',
      icon: DocumentIcon,
    },
    {
      tag: 'Reviews',
      title: 'Receive reviews and feedback from your clients',
      icon: StarsBlueIcon,
    },

    {
      tag: 'Fast-Payment',
      title:
        'Process credit card transactions directly in the mobile app with the lowest industry fees ',
      icon: CardIcon,
    },
    {
      tag: 'Time cards',
      title: `Keep track of your employees' work hours`,
      icon: ClockTimeIcon,
    },
  ],
};

const whatIs = {
  title: 'What is Orcatec?',
  subTitle:
    'Orcatec is your all-in-one home services management software designed to save you time, money, and boost productivity. It organizes all your tasks, synchronizes the work of your team, technicians, and clients.',
  items: [
    {
      title: '60% Times Saved on Reporting, Invoicing & Planning',
      icon: CardIcon,
    },
    { title: '120% Return on Investments on the First Year', icon: WalletIcon },
    { title: 'Customize Online Platform for Your Field', icon: LaptopIcon },
    { title: 'Quickbooks Automatic Synchronization', icon: GroupIcon },
  ],
  image: {
    imageMob: whatIsMobImage.src,
    imageDesk: whatIsDeskImage.src,
  },
};

const awards = {
  title: 'Success Recognized By A Collection Of Awards.',
  subTitle: `Orcatec takes pride in its numerous awards, a testament to 
     our commitment to innovation and excellence in field business software.`,
  images: [
    { src: awards1.src, alt: '1' },
    { src: awards1.src, alt: '2' },
    { src: awards1.src, alt: '3' },
    { src: awards1.src, alt: '4' },
    { src: awards1.src, alt: '5' },
  ],
};

const awards2 = [
  {
    sectionTitle: '2024',
    articleText:
      'In 2024, we continued to receive accolades, highlighting our ongoing commitment to improvement and our focus on meeting the needs of our customers. This recognition reflects our ability to adapt to changes, providing cutting-edge solutions and unparalleled service. ',
    images: [
      { image: awards1_2024 },
      { image: awards2_2024 },
      { image: awards3_2024 },
      { image: awards4_2024 },
      { image: awards5_2024 },
      { image: awards6_2024 },
    ],
  },
  {
    sectionTitle: '2023',
    articleText:
      '2023 was a year of recognition for Orcatec, as we earned prestigious awards, showcasing our commitment to excellence and innovation. These accolades affirmed our unwavering dedication to delivering a high-quality product and exceptional customer service.',
    images: [
      { image: awards1_2023 },
      { image: awards2_2023 },
      { image: awards3_2023 },
      { image: awards4_2023 },
      { image: awards5_2023 },
      { image: awards6_2023 },
    ],
  },
];

const blog = {
  title: 'Our Blog',
  description: `Dive into a wealth of insights tailored to your industry with Orcatec's blog, your go-to resource 
    for the latest trends and tips in service scheduling software free`,
};

const bookDemo = {
  title: `Book A Demo То 
  Streamlining Your Scheduling!`,
  description: `Elevate your business efficiency with Orcatec. Fill out the form below for personalized demonstration and expert recommendations. We're here to help you optimize every appointment and task.`,
};

const partners = {
  items: [
    {
      image: GarantImage,
      alt: ' appliance servicecenter company',
    },
    {
      image: RemovalImage,
      alt: 'removal pro company',
    },
    {
      image: AirloopImage,
      alt: 'air loop company',
    },
    {
      image: BuildxImage,
      alt: 'buildx company',
    },
  ],
};

const articles = {
  title: `How Does Job 
  Scheduling Software Work?`,
  items: [
    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_1,
        alt: 'Optimize Field Operations',
      },
      list: [],
      href: '#',
      tag: '',
      title: 'Client Management and Communication',
      text: 'Focuses on building detailed client profiles for personalized service. Despite manual scheduling, it ensures client satisfaction through direct reminders, notifications, and tailored marketing, fostering strong connections and loyalty',
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_2,
        alt: 'Customer management',
      },
      list: [],
      href: '#',
      tag: '',
      title: 'Staff Scheduling and Management',
      text: 'Manages team schedules and assignments manually, considering individual skills and availability. This process ensures efficient task distribution and coverage, emphasizing direct management and personal oversight.',
    },

    {
      type: ArticleType.HORIZONTAL,
      image: {
        path: schedule_3,
        alt: 'Manual Appointment Scheduling',
      },
      list: [],
      href: '#',
      tag: '',
      title: 'Manual Appointment Scheduling',
      text: 'This method relies on dispatchers or field workers to manually manage appointment bookings, offering personalized scheduling and flexibility. It emphasizes human interaction, accommodating client preferences and changes with a personal touch.',
    },
  ],
};

const fullArticle1 = {
  image: {
    path: app_1,
    alt: `Why Orcatec 
    is Right For You?`,
  },
  title: `Why Orcatec 
  is Right For You?`,
  description: `Contractors are increasingly selecting Orcatec for their scheduling needs due to its comprehensive, flexible, and user-friendly software solutions. Be familiar with the main reasons for choosing us:`,
  item: [
    {
      title: 'Zero-Cost Entry',
      description:
        'Unlike our competitors, Orcatec introduces a free tariff plan. This allows you to experience essential scheduling functionalities without financial obligations, offering a risk-free exploration of how our software can cater to your specific needs',
    },
    {
      title: 'Customizable Solutions',
      description:
        'Orcatec stands out with its flexible paid packages. You have the liberty to select and pay only for the functionalities that match your business requirements. This a-la-carte approach ensures your subscription grows and adapts with your business, optimizing both cost-efficiency and utility.',
    },
    {
      title: 'Immediate Support',
      description:
        'Fast and reliable online support is a cornerstone of our service. Whenever you encounter a hurdle, our dedicated team is just a click away, ensuring minimal downtime and maximum productivity.',
    },
  ],
};

const fullArticle2 = {
  image: {
    path: app_2,
    alt: `What Is 
    Scheduling Software?`,
  },
  title: `What Is 
  Scheduling Software?`,
  description: `Scheduling software is crucial for efficiently managing appointments, resources, and staff schedules. Orcatec's online job scheduling software solution acts as a comprehensive job scheduling tool designed to streamline these processes for businesses. It combines a centralized scheduling dashboard, automated scheduling algorithms, real-time updates, and seamless integration capabilities, making it a powerful job scheduling system for various industries. The key features are:`,
  item: [
    {
      title: 'Automated Resource Allocation',
      description:
        'Minimizes overbooking and optimizes resource use, ensuring an efficient job scheduling system',
    },
    {
      title: 'Error Reduction',
      description:
        'Reduces manual scheduling errors, enhancing operational reliability',
    },

    {
      title: 'Improved Customer Experience',
      description: `Offers easy booking and real-time adjustments, boosting customer satisfaction`,
    },
  ],
};

const explore = {
  title: 'Explore More ',
  subtitle: 'Tools For Job Success',
  description: `Dive into a wealth of insights tailored to your industry with Orcatec's blog, your go-to resource 
  for the latest trends and tips in service scheduling software free`,
  image: explore_image,
  items: [
    {
      title: 'Complete Job & Invoice',
      path: IRoutePath.FEATURES_INVOICING,
      icon: WalletIcon,
      items: [
        {
          title: 'Sales Proposal Tool',
          path: '',
        },

        {
          title: 'Invoicing',
          path: '',
        },
        {
          title: 'Estimates',
          path: '',
        },
        {
          title: 'Quoting',
          path: '',
        },
      ],
    },
    {
      title: 'Scheduling & Dispatching',
      path: IRoutePath.FEATURES_SCHEDULIG,
      icon: CalendarIcon,
      items: [
        {
          title: 'Employee GPS Tracking',
          path: '',
        },
        {
          title: 'Scheduling Software',
          path: '',
        },
        {
          title: 'Route Optimization',
          path: '',
        },
        {
          title: 'Field Service App',
          path: '',
        },
        {
          title: 'Voice Solutions',
          path: '',
        },
        {
          title: 'Dispatching',
          path: '',
        },
      ],
    },
    {
      title: 'Get Paid & Expenses',
      path: IRoutePath.FEATURES,
      icon: CardIcon,
      items: [
        {
          title: 'Commissions Management',
          path: '',
        },
        {
          title: 'Home Services Marketing',
          path: '',
        },
        {
          title: 'Automated Direct Mail',
          path: '',
        },
        {
          title: 'Consumer Financing',
          path: '',
        },
        {
          title: 'Advanced Reporting',
          path: '',
        },
        {
          title: 'Expenses Tracking',
          path: '',
        },

        {
          title: 'Contractor Payroll',
          path: '',
        },
        {
          title: 'Card Reader',
          path: '',
        },
      ],
    },
    {
      title: 'Job Management',
      icon: ToolsIcon,
      path: IRoutePath.FEATURES,
      items: [
        {
          title: 'Work Order Management',
          path: '',
        },
        {
          title: 'Field Service CRM',
          path: '',
        },
        {
          title: 'Job Management',
          path: '',
        },
        {
          title: 'Job Tracking',
          path: '',
        },
        {
          title: 'Job Costing',
          path: '',
        },
      ],
    },
  ],
};

export {
  awards,
  whatIs,
  potential,
  services,
  reviews,
  testimonals,
  faq,
  blog,
  bookDemo,
  partners,
  awards2,
  intro,
  articles,
  fullArticle1,
  fullArticle2,
  explore,
};
